export default "__VITE_ASSET__C_vIPfR$__"